// Comparaison de deux versions d'une démarche : choix des versions, liste des changements en mots
// (ajouté, modifié, supprimé) par zone, étapes supprimées signalées (migration impossible).
import { Bandeau, LienBouton, Panneau, Selection } from '@cc/ui';
import { ArrowLeft } from 'lucide-react';
import { useParams, useSearchParams } from 'react-router';
import { EnTetePage } from '../../commun/EnTetePage';
import { EtatRequete } from '../../commun/EtatRequete';
import { ListeChangements } from './ActionsVersion';
import { comparerContenus, etapesSupprimees } from './comparaison';
import { LIBELLES_ETAT_VERSION, normaliserContenu, useDemarche, useServices, useVersion } from './contenu';
import commun from '../../commun/commun.module.css';

export function PageComparaisonVersions() {
  const { id = '' } = useParams();
  const [params, setParams] = useSearchParams();
  const demarche = useDemarche(id);
  const services = useServices();
  const d = demarche.data;
  const numeros = (d?.versions ?? []).map((v) => v.numero).sort((a, b) => a - b);
  const de = Number(params.get('de')) || numeros[Math.max(0, numeros.length - 2)] || 1;
  const a = Number(params.get('a')) || numeros[numeros.length - 1] || 1;
  const vDe = useVersion(id, de);
  const vA = useVersion(id, a);
  const contenuDe = vDe.data ? normaliserContenu(vDe.data.contenu, d) : null;
  const contenuA = vA.data ? normaliserContenu(vA.data.contenu, d) : null;
  const changements = contenuDe && contenuA ? comparerContenus(contenuDe, contenuA, new Map((services.data ?? []).map((s) => [s.id, s.nom]))) : [];
  const supprimees = contenuDe && contenuA ? etapesSupprimees(contenuDe, contenuA) : [];
  const options = (d?.versions ?? []).map((v) => ({ valeur: String(v.numero), libelle: `Version ${v.numero} (${LIBELLES_ETAT_VERSION[v.etat] ?? v.etat})` }));
  const changer = (cle: 'de' | 'a', valeur: string) => setParams((p) => { p.set(cle, valeur); return p; }, { replace: true });

  return (
    <>
      <EnTetePage etiquette={d ? `Démarches / ${d.libelle}` : 'Démarches'} titre="Comparaison des versions" actions={<LienBouton href={`/demarches/${id}`} icone={ArrowLeft}>Fiche de la démarche</LienBouton>} />
      <EtatRequete chargement={demarche.isPending || vDe.isPending || vA.isPending} erreur={demarche.error ?? vDe.error ?? vA.error} lot="L1-A" fonction="La comparaison des versions">
        <div className={commun.pile}>
          <div className={commun.ligne}>
            <Selection libelle="Version de référence" value={String(de)} options={options} onChange={(e) => changer('de', e.target.value)} />
            <Selection libelle="Version comparée" value={String(a)} options={options} onChange={(e) => changer('a', e.target.value)} />
          </div>
          <Panneau titre={`Ce que change la version ${a} par rapport à la version ${de}`}>
            {de === a ? <p className={commun.na}>Choisissez deux versions différentes.</p> : <ListeChangements changements={changements} vide="Aucune différence entre ces deux versions." />}
            {supprimees.length > 0 ? <Bandeau type="attention">Étapes supprimées : {supprimees.join(', ')}. Un dossier déjà arrivé à l'une de ces étapes ne peut pas être migré vers la version {a}.</Bandeau> : null}
          </Panneau>
        </div>
      </EtatRequete>
    </>
  );
}
